module.exports = {
	props:['onRemove','onUpload'],

	compiled: function() {
		var img_src = 'src/img/' + this.fileobject.name.split('.').pop() + '.png'
		this.$$.filelogo.src = img_src
	}
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/components/upload-file.vue
// module id = 146
// module chunks = 0